var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-banner"},[_c('div',{staticClass:"container-fluid banner"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 shop-title"},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.store.Name))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }